import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const airbase = defineConnector({
  identifier: "airbase",
  name: "Airbase",
  tagLine: "Spend management and procurement",
  logo,
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://api\\.airbase\\.io/.*",
  protocol: "http",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Generate an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Airbase, go to **Settings > Integrations > API** and generate a new API key. You need admin permissions to do this.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.airbase.io/v1/accounting/vendors/?page=1&page_size=1&erp_reference_id=",
      expectedStatus: 200,
    }),
  },
});
